import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { LinkButton } from 'app/components/core/LinkButton';
import {
    Snackbar,
    SnackbarMessage,
    SnackbarVariant,
    SnackbarAction
} from 'app/components/core/Snackbar';

import { downloadDataset } from 'app/lib/utils/download';
import { doDownloadFailed } from 'app/store/downloadView';

function PrepareDownloadSucceededNotification({
    id,
    onDismiss,
    onDownloadFailed,
    viewName,
    targetName = null,
    preparedDownloadFilename,
    autoHideDelay
}) {
    const { t } = useTranslation();

    const onDownloadFailure = (error) => onDownloadFailed(viewName, error);
    const onDownloadSucceeded = () => onDismiss(id);
    const onDownload = () => {
        downloadDataset({
            viewName,
            preparedDownloadFilename,
            onDownloadSucceeded,
            onDownloadFailure
        });
    };

    let downloadMessage;
    if (targetName) {
        downloadMessage = t(`notifications:DownloadExplorationPrepared`, {
            viewName,
            targetName
        });
    } else {
        downloadMessage = t('notifications:DownloadPrepared', {
            viewName
        });
    }

    return (
        <Snackbar
            id={id}
            onDismiss={onDismiss}
            variant={SnackbarVariant.SUCCESS}
            autoHideEnabled
            autoHideDelay={autoHideDelay}>
            <SnackbarMessage>{downloadMessage}</SnackbarMessage>
            <SnackbarAction>
                <LinkButton id={id} onClick={onDownload}>
                    {t('common:downloadNow')}
                </LinkButton>
            </SnackbarAction>
        </Snackbar>
    );
}

PrepareDownloadSucceededNotification.propTypes = {
    id: PropTypes.string.isRequired,
    onDismiss: PropTypes.func.isRequired,
    onDownloadFailed: PropTypes.func.isRequired,
    viewName: PropTypes.string.isRequired,
    targetName: PropTypes.string,
    preparedDownloadFilename: PropTypes.string.isRequired,
    autoHideDelay: PropTypes.number.isRequired
};

const mapStateToProps = createStructuredSelector({});

const mapDispatchToProps = {
    onDownloadFailed: doDownloadFailed
};

export const PrepareDownloadSucceededNotificationContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(PrepareDownloadSucceededNotification);
